<template>
  <nuttrema-layout-west-three-vertical>
    <div slot="top-center" class="top--center__title">
      <span>{{ $t('label.copy_day') }}</span>
    </div>

    <template slot="center">
      <div class="manage-program-days">
        <div class="form-east-block-layout">

          <template v-if="_get(ProgramDetails, 'saveError')">
            <el-row type="flex" style="align-self: stretch">
              <el-col :span="24">
                <nuttrema-form-alert :error="_get(ProgramDetails, 'saveError')" style="margin: 1em 0.5em 0"></nuttrema-form-alert>
              </el-col>
            </el-row>
          </template>

          <section>
            <h4 class="section-title">{{ $t('label.program_info') }}</h4>
            <div class="section-items">
              <div class="manage-program-days__diet-info">
                <div class="diet-info--date" v-if="startDate">
                  <div>
                    <p><span class="ttl">{{ $t('label.start_date') }}</span>: {{ $d(new Date(startDate), 'short') }}</p>
                    <p><span class="ttl">{{ $t('label.end_date') }}</span>: {{ $d(moment(startDate).add(list.length - 1, 'day').toDate(), 'short') }}</p>
                  </div>
                </div>
                <div class="diet-info--duration">
                  <div>
                    <p><span class="ttl">{{ $t('label.duration_days') }}</span>: {{ list.length }}</p>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </div>

        <div class="form-east-block-layout">
          <section>
            <h4 class="section-title">{{ $t('label.list_of_days') }}</h4>
            <div class="section-items">
              <draggable class="manage-program-days-list" v-model="list" :move="checkMove" @end="onEnd">
                <div
                   v-for="(day, index) in list"
                   class="manage-program-days__day"
                  :class="{ 'is-addded': day.added }"
                  :key="day.id">
                  <div class="day__move" :class="{ 'is-disabled': !day.added }">
                    <i class="far fa-arrows-v"></i>
                  </div>
                  <div class="day__date">
                    <div class="day__date__label" v-if="startDate">
                      <p class="day__date__label--month">{{ moment(startDate).add(index, 'day').format('MMM') }}</p>
                      <p class="day__date__label--day">{{ moment(startDate).add(index, 'day').format('Do') }}</p>
                      <p v-if="day.id && day.date !== moment(startDate).add(index, 'day').format('YYYY-MM-DD')" class="day__date__label--old-date">{{ day.date | moment('Do MMM') }}</p>
                    </div>
                    <div class="day__date__label" v-else>
                      <p class="day__date__label--day-of-diet">&nbsp;</p>
                      <p class="day__date__label--day">{{ $t('label.day') }} {{ index + 1 }}</p>
                      <p v-if="day.id && day.dayNumber !== index + 1" class="day__date__label--old-date">{{ $t('label.day') }} {{ day.dayNumber }}</p>
                    </div>
                  </div>
                  <div class="day__description">
                    <div class="description--title">
                      <input-edit-in-place
                         class="ttl is-transparent"
                         name="title"
                        :params="day.dayNumber"
                        :placeholder="$t('label.click_to_add_day_title')"
                        :value="day.title"
                        :disabled="!day.added"
                        @edited="onTitleOrNoteUpdate">
                      </input-edit-in-place>
                    </div>
                    <div class="description--note">
                      <input-edit-in-place
                         class="note is-transparent"
                         name="note"
                        :params="day.dayNumber"
                        :placeholder="$t('label.click_to_add_day_note')"
                        :value="day.note"
                        :disabled="!day.added"
                        @edited="onTitleOrNoteUpdate">
                      </input-edit-in-place>
                    </div>
                    <div class="description--schedules"></div>
                  </div>
                  <div class="day__copy" v-if="day.added">{{ $t('label.copy') }}</div>
                </div>
                <!-- end ~ manage-program-days__day -->
              </draggable>
            </div>
          </section>
          <p class="section-help">{{ $t('label.copy_program_day_help') }}</p>
        </div>
      </div>
      <!-- end ~ manage_diet_days -->
    </template>

    <template slot="bottom-left">
      <el-button
         type="primary"
         size="small"
        :loading="ProgramDetails.saving"
        @click="handleCopyDay">
        {{ $t('label.copy_day') }}
      </el-button>
    </template>

    <template slot="bottom-right">
      <el-button
        size="small"
        type="text"
        @click="handleFormCancel">
        {{ $t('label.cancel') }}
      </el-button>
    </template>
  </nuttrema-layout-west-three-vertical>
</template>

<script>
import { get, omitBy, isNil, each, find } from 'lodash';

import NuttremaFormAlert from 'components/ui/alert/nuttrema-form-alert';

import ManageProgramDays from './cmpt-manage-program-days';

export default {
  name: 'cmpt-copy-program-day',
  mixins: [
    ManageProgramDays,
  ],
  components: {
    NuttremaFormAlert,
  },
  methods: {
    getPayload() {
      const payload = {
        title: null,
        note: null,
        day_number: null,
      };
      each(this.list, (item, index) => {
        if (item.added) {
          payload.title = item.title;
          payload.note = item.note;
          payload.day_number = index + 1;
        }
      });
      return omitBy(payload, isNil);
    },
    handleAddNewDay() {
      const dayNumber = this.list.length + 1;
      const original = find(this.list, item => Number(item.id) === Number(this.dayID));
      this.list.push({
        id: null,
        date: 'dummy',
        newDate: null,
        dayNumber,
        title: get(original, 'title', null),
        note: get(original, 'note', null),
        added: true,
      });
    },
    handleCopyDay() {
      const payload = this.getPayload();
      console.log('handleCopyDay', payload);
      this.$emit('submit', payload);
    },
    handleFormCancel() {
      this.$emit('cancel');
    },
    checkMove(evt) {
      return get(evt, 'draggedContext.element.added', false);
    },
  },
  created() {
    this.handleAddNewDay();
  },
};
</script>



// WEBPACK FOOTER //
// src/components/pages/professional/programs/shared/schedules/manage/cmpt-copy-program-day.vue